<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- latest transactions -->
        <div class="is-flex section-title">
          <h2 class="is-marginless">{{ $t("res.latest_transactions") }}</h2>
        </div>
        <ticker-transaction-table v-bind:transactions="transactions"></ticker-transaction-table>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
  import TickerTransactionTable from '../components/layout/TickerTransactionTable'

  export default {
    name: 'Ticker',
    components: {TickerTransactionTable},
    computed: {
      transactions () {
        return this.$store.state.chainStatus.latestTransactions.slice(0, 20)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    min-height: 77vh;
  }

  .section-title {
    padding-top: 1rem;
    margin-bottom: 1rem;
    align-items: flex-end;

    h2 {
      padding-left: 4rem;
    }
  }

  div > h2 {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/Ticker.vue